export var FormPreset;
(function (FormPreset) {
    FormPreset["CONTACT_FORM"] = "contact-form";
    FormPreset["GET_SUBSCRIBERS"] = "get-subscribers";
    FormPreset["PAYMENT_FORM"] = "paymentForm01";
    FormPreset["POTENTIAL_CUSTOMERS"] = "potential-customers";
    FormPreset["SALES_LEAD"] = "sales-lead";
    FormPreset["SUPPORT_REQUEST"] = "support-request";
    FormPreset["TESTIMONIAL"] = "testimonial";
    FormPreset["JOB_APPLICATION"] = "job-application";
    FormPreset["CUSTOMER_SATISFACTION"] = "customer-satisfaction";
    FormPreset["PRICE_QUOTE"] = "price-quote";
    FormPreset["CONTEST_ENTRY"] = "contest-entry";
    FormPreset["QUIZ"] = "quiz";
    FormPreset["MULTI_STEP_REGISTRATION_FORM"] = "multi-step-registration-form";
    FormPreset["MULTI_STEP_SALES"] = "multi-step-sales";
    FormPreset["REGISTRATION_FORM"] = "registration-form";
    FormPreset["CUSTOM_REGISTRATION_WITH_COMMUNITY"] = "customSignup01";
})(FormPreset || (FormPreset = {}));
export var ResponsiveFormPreset;
(function (ResponsiveFormPreset) {
    ResponsiveFormPreset["CONTACT"] = "responsiveContactForm02";
    ResponsiveFormPreset["SUBSCRIBERS"] = "responsiveSubscribers01";
    ResponsiveFormPreset["SALES_LEAD"] = "responsiveSales02";
    ResponsiveFormPreset["JOB_APPLICATION"] = "responsiveJobApplication01";
})(ResponsiveFormPreset || (ResponsiveFormPreset = {}));
export var ResponsiveGridFormPreset;
(function (ResponsiveGridFormPreset) {
    ResponsiveGridFormPreset["CONTACT"] = "responsiveGridContactForm02";
    ResponsiveGridFormPreset["SUBSCRIBERS"] = "responsiveGridSubscribers02";
    ResponsiveGridFormPreset["SALES_LEAD"] = "responsiveGridSales02";
    ResponsiveGridFormPreset["JOB_APPLICATION"] = "responsiveGridJobApplication01";
})(ResponsiveGridFormPreset || (ResponsiveGridFormPreset = {}));
export var FormPresetType;
(function (FormPresetType) {
    FormPresetType["PAYMENT"] = "payment";
})(FormPresetType || (FormPresetType = {}));
export var LIGHTBOX_PRESETS;
(function (LIGHTBOX_PRESETS) {
    LIGHTBOX_PRESETS["LIGHTBOX_CONTACT01"] = "lightbox_contact01";
    LIGHTBOX_PRESETS["LIGHTBOX_CONTACT02"] = "lightbox_contact02";
    LIGHTBOX_PRESETS["LIGHTBOX_CONTACT03"] = "lightbox_contact03";
    LIGHTBOX_PRESETS["LIGHTBOX_CONTACT04"] = "lightbox_contact04";
    LIGHTBOX_PRESETS["LIGHTBOX_CONTACT05"] = "lightbox_contact05";
    LIGHTBOX_PRESETS["LIGHTBOX_CONTACT06"] = "lightbox_contact06";
    LIGHTBOX_PRESETS["LIGHTBOX_PROMOTION01"] = "lightbox_promotion01";
    LIGHTBOX_PRESETS["LIGHTBOX_SUBSCRIBE01"] = "lightbox_subscribe01";
    LIGHTBOX_PRESETS["LIGHTBOX_SUBSCRIBE02"] = "lightbox_subscribe02";
    LIGHTBOX_PRESETS["LIGHTBOX_SUBSCRIBE03"] = "lightbox_subscribe03";
    LIGHTBOX_PRESETS["LIGHTBOX_SUBSCRIBE04"] = "lightbox_subscribe04";
    LIGHTBOX_PRESETS["LIGHTBOX_SUBSCRIBE05"] = "lightbox_subscribe05";
    LIGHTBOX_PRESETS["lightbox_SUBSCRIBE06"] = "lightbox_subscribe06";
    LIGHTBOX_PRESETS["LIGHTBOX_SUBSCRIBE07"] = "lightbox_subscribe07";
    LIGHTBOX_PRESETS["LIGHTBOX_SUBSCRIBE08"] = "lightbox_subscribe08";
})(LIGHTBOX_PRESETS || (LIGHTBOX_PRESETS = {}));
export var STRIPS_PRESETS;
(function (STRIPS_PRESETS) {
    STRIPS_PRESETS["STRIPS_CONTACT01"] = "strips_contact01";
    STRIPS_PRESETS["STRIPS_CONTACT02"] = "strips_contact02";
    STRIPS_PRESETS["STRIPS_CONTACT03"] = "strips_contact03";
    STRIPS_PRESETS["STRIPS_CONTACT04"] = "strips_contact04";
    STRIPS_PRESETS["STRIPS_CONTACT05"] = "strips_contact05";
    STRIPS_PRESETS["STRIPS_CONTACT06"] = "strips_contact06";
})(STRIPS_PRESETS || (STRIPS_PRESETS = {}));
//# sourceMappingURL=form-types.js.map